import { getAll } from '@/api/supportCommercial';
import { CATEGORIE_PRODUIT, CATEGORIE_PRODUIT_ACHAT } from '@/configuration/catalogue/produitConf';
import { cloneDeep } from 'lodash';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import {
  SET_CATEGORIES,
  RESET_STATE,
  SET_SUPPORT_COMMERCIAUX,
  SET_CATEGORIES_ACHAT,
} from './categorieVente-mutation-type';

const state = {
  categorieProduit: [],
  supportCommerciaux: [],
  categorieProduitAchat: [],
};

const namespaced = true;

const mutations = {
  [SET_CATEGORIES](state, categories) {
    state.categorieProduit = categories;
  },
  [SET_CATEGORIES_ACHAT](state, categories) {
    state.categorieProduitAchat = categories;
  },
  [SET_SUPPORT_COMMERCIAUX](state, supports) {
    state.supportCommerciaux = supports;
  },
  [RESET_STATE](state) {
    state.categorieProduit = [];
    state.categorieProduitAchat = [];
    state.supportCommerciaux = [];
  },
};

const actions = {
  async loadCategories({ commit, rootState }) {
    const payload = {
      query: {
        societeId: rootState.societe.societeActiveId,
        filteredByModule: true,
      },
      limit: NO_PAGINATION,
    };
    const response = (await getAll(payload)).data.result.items;
    commit(SET_SUPPORT_COMMERCIAUX, response);
    const categories = cloneDeep(CATEGORIE_PRODUIT).filter(categorie => {
      return response.map(item => item.categorieVente).includes(categorie.code);
    });
    commit(SET_SUPPORT_COMMERCIAUX, response);
    const categoriesAchat = cloneDeep(CATEGORIE_PRODUIT_ACHAT).filter(categorie => {
      return response.map(item => item.categorieVente).includes(categorie.code);
    });
    commit(SET_CATEGORIES, categories);
    commit(SET_CATEGORIES_ACHAT, categoriesAchat);
  },
  async purgerCategorieVente({ dispatch, commit }) {
    commit(SET_SUPPORT_COMMERCIAUX, []);
    commit(SET_CATEGORIES, []);
    commit(SET_CATEGORIES_ACHAT, []);
    await dispatch('loadCategories');
  },
};

const getters = {
  categorieProduit: state => {
    return cloneDeep(state.categorieProduit);
  },
  categorieProduitAchat: state => {
    return cloneDeep(state.categorieProduitAchat);
  },
  categorieProduitByCode: state => {
    return cloneDeep(state.categorieProduit.map(categorie => categorie.code));
  },
  categorieProduitAchatByCode: state => {
    return cloneDeep(state.categorieProduitAchat.map(categorie => categorie.code));
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
